// Hay nombres que traen la cantidad pedida escrita al inicio ("100 metros de cable de fibra"). La cantidad
// se escribe en su propio campo; dejarla en el nombre confunde cuando se aprueba otra cantidad.
const REGEX_CANTIDAD_EN_NOMBRE =
  /^\s*(\d+(?:[.,]\d+)?)\s*(metros?|mts?|unidades?|und|cajas?|litros?|lts?|gal[oó]n(?:es)?|cubetas?|rollos?|piezas?|pares?)\s+(?:de\s+)?/i;

// Unidad de la lista de unidades del sistema según la palabra escrita en el nombre.
function unidadDePalabra(palabra) {
  const t = palabra.toLowerCase();
  if (/^(metro|mt)/.test(t)) return "Metro";
  if (/^caja/.test(t)) return "Caja";
  if (/^(litro|lt)/.test(t)) return "Litro";
  if (/^gal/.test(t)) return "Galón";
  if (/^cubeta/.test(t)) return "Cubeta";
  if (/^(unidad|und|pieza)/.test(t)) return "Unidad";
  return "";
}

// "100 metros de cable de fibra" -> { limpio: "Cable de fibra", cantidad: "100", unidad: "Metro", textoQuitado: "100 metros" }
// Si el nombre no empieza con una cantidad, devuelve null.
export function separarCantidadDelNombre(nombre) {
  const m = String(nombre || "").match(REGEX_CANTIDAD_EN_NOMBRE);
  if (!m) return null;
  const resto = String(nombre).replace(REGEX_CANTIDAD_EN_NOMBRE, "").trim();
  if (!resto) return null;
  return {
    limpio: resto.charAt(0).toUpperCase() + resto.slice(1),
    cantidad: m[1].replace(",", "."),
    unidad: unidadDePalabra(m[2]),
    textoQuitado: `${m[1]} ${m[2]}`,
  };
}

// Solo para MOSTRAR (tablas de productos entregados): el nombre sin la cantidad escrita al inicio.
export function nombreSinCantidad(nombre) {
  const r = separarCantidadDelNombre(nombre);
  return r ? r.limpio : nombre;
}
